import { useState, useEffect } from 'react'

interface CountdownResult {
  hours: number
  minutes: number
  seconds: number
  expired: boolean
  totalSeconds: number
}

export function useCountdown(targetDate: Date | null): CountdownResult {
  const [timeLeft, setTimeLeft] = useState(() => {
    if (!targetDate) return 0
    return Math.max(0, Math.floor((targetDate.getTime() - Date.now()) / 1000))
  })

  useEffect(() => {
    if (!targetDate) return
    const tick = () => {
      const remaining = Math.max(0, Math.floor((targetDate.getTime() - Date.now()) / 1000))
      setTimeLeft(remaining)
    }
    tick()
    const id = setInterval(tick, 1000)
    return () => clearInterval(id)
  }, [targetDate])

  const hours = Math.floor(timeLeft / 3600)
  const minutes = Math.floor((timeLeft % 3600) / 60)
  const seconds = timeLeft % 60

  return { hours, minutes, seconds, expired: timeLeft === 0, totalSeconds: timeLeft }
}
